// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Filters_wrapper__3eCfN","swiper":"Filters_swiper__1DXA6","visible":"Filters_visible__4K2T8"};